export const ORDER_STEP_3_SMALL_ORDER_LIMIT = 3;
export const ORDER_STEP_5_SMALL_ORDER_LIMIT = 3;
export const ORDER_STEP_1_SIZE_LARGE = 440;
export const ORDER_STEP_1_SIZE_SMALL = 320;
export const DRAWER_SWIPEABLE_AREA_HEIGHT = 160;
export const DRAWER_OPEN_HEIGHT = 760; // 920px - 160px (puller height)
export const DRAWER_CLOSED_HEIGHT = 320;
export const DRAWER_TOTAL_HEIGHT = DRAWER_OPEN_HEIGHT + DRAWER_SWIPEABLE_AREA_HEIGHT;
